<template>
  <li v-if="targetFunders.length" class="flex items-center">
    <input
      :id="value"
      v-model="types"
      :value="value"
      type="checkbox"
      class="form-checkbox rounded-xs border-gray-300 text-indigo-600"
    />
    <label class="ml-2 cursor-pointer" :for="value">
      {{ wordsFirstLetterToUpper(value) }}
      <span class="text-gray-400">({{ targetFunders.length }})</span>
    </label>
  </li>
</template>

<script setup lang="ts">
import { wordsFirstLetterToUpper } from "@/helpers/formatting";

import type { SubmissionMethod } from "@/enums/placement";
import type { IFunder } from "@/models/funders";

defineProps<{
  targetFunders: IFunder[];
  value: SubmissionMethod;
}>();

const types = defineModel<SubmissionMethod[]>({ required: true });
</script>
